<template>
  <v-app class="grey lighten-3">
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <div><span class="headline">Payment Method</span></div>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-2 text-none" small dark @click="back">
                Back
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text title">
                    Your Total Budget:
                  </v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text headline">
                    {{ indexData.datas.total_budget_amount }} Tk
                  </v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text title">
                    Minimum Payable Amount:
                  </v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text headline">
                    {{
                      indexData.datas.payable_amount == 0
                        ? 10
                        : indexData.datas.payable_amount
                    }}
                    Tk
                  </v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text title">
                    Inter Your Expected Amount:
                  </v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="editedItem.paid_amount"
                    type="number"
                    prefix="Tk"
                    box
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-subheader class="black--text title">
                    Select Your Payment Method
                  </v-subheader>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 md12>
                  <v-btn
                    class="pay-button text-none"
                    flat
                    @click="bkash"
                    :disabled="clicked"
                  >
                    Bkash
                  </v-btn>
                  <v-btn
                    class="pay-button text-none"
                    flat
                    @click="nagad"
                    :disabled="clicked"
                  >
                    Nagad
                  </v-btn>
                  <v-btn
                    class="pay-button text-none"
                    flat
                    @click="cheque"
                    :disabled="clicked"
                  >
                    Cheque
                  </v-btn>
                  <v-btn
                    class="pay-button text-none"
                    flat
                    @click="beftn"
                    :disabled="clicked"
                  >
                    BEFTN
                  </v-btn>
                  <v-btn
                    class="pay-button text-none"
                    flat
                    @click="paymentGateway"
                    :disabled="clicked"
                  >
                    Payment Gateway
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-dialog v-model="dialog" max-width="700px">
                <v-card v-if="this.payment_method_id == 1">
                  <v-card-title class="indigo">
                    <div><span class="headline">Bkash Payment</span></div>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    <v-container grid-list-md>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row>
                          <v-flex xs6>
                            <v-subheader class="black--text">
                              Transaction ID:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.transaction_id"
                              :rules="[(v) => !!v || 'This field is required!']"
                              placeholder="Transaction ID"
                              box
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-subheader class="black--text">
                              Bkash Number:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.account_number"
                              :rules="phoneRules"
                              type="number"
                              placeholder="Bkash number"
                              box
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Amount:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.paid_amount"
                              readonly
                              box
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Date:
                            </v-subheader>
                            <v-menu
                              ref="menu"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="190px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.trasanction_date"
                                  :rules="[
                                    (v) => !!v || 'This field is required!',
                                  ]"
                                  placeholder="YYY-MM-DD format"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  box
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="editedItem.trasanction_date"
                                :min="new Date().toISOString().substr(0, 10)"
                                @change="save"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Time:
                            </v-subheader>
                            <v-menu
                              ref="menu"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="editedItem.trasanction_time"
                                  :rules="[
                                    (v) => !!v || 'This field is required!',
                                  ]"
                                  placeholder="H:M format"
                                  readonly
                                  v-on="on"
                                  box
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu2"
                                v-model="editedItem.trasanction_time"
                                full-width
                                @click:minute="$refs.menu.save(time)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Page Photo:
                            </v-subheader>
                          </v-flex>
                          <v-flex xs4>
                            <BkashImageUpload
                              @change="onImageChange($event)"
                              select-text="Select file"
                            />
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn class="error text-none" flat @click="close">
                      Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="success text-none"
                      flat
                      @click="submit"
                      :disabled="clicked"
                    >
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <v-card v-else-if="this.payment_method_id == 2">
                  <v-card-title class="indigo">
                    <div><span class="headline">Nagad Payment</span></div>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    <v-container grid-list-md>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row>
                          <v-flex xs6>
                            <v-subheader class="black--text">
                              Transaction ID:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.transaction_id"
                              :rules="[(v) => !!v || 'This field is required!']"
                              placeholder="Transaction ID"
                              box
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-subheader class="black--text">
                              Nagad Number:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.account_number"
                              :rules="phoneRules"
                              type="number"
                              placeholder="Nagad number"
                              box
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Amount:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.paid_amount"
                              readonly
                              box
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Date:
                            </v-subheader>
                            <v-menu
                              ref="menu"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="190px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.trasanction_date"
                                  :rules="[
                                    (v) => !!v || 'This field is required!',
                                  ]"
                                  placeholder="YYY-MM-DD format"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  box
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="editedItem.trasanction_date"
                                :min="new Date().toISOString().substr(0, 10)"
                                @change="save"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Time:
                            </v-subheader>
                            <v-menu
                              ref="menu"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="editedItem.trasanction_time"
                                  :rules="[
                                    (v) => !!v || 'This field is required!',
                                  ]"
                                  placeholder="H:M format"
                                  readonly
                                  v-on="on"
                                  box
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu2"
                                v-model="editedItem.trasanction_time"
                                full-width
                                @click:minute="$refs.menu.save(time)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Page Photo:
                            </v-subheader>
                          </v-flex>
                          <v-flex xs4>
                            <BkashImageUpload
                              @change="onImageChange($event)"
                              select-text="Select file"
                            />
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn class="error text-none" flat @click="close">
                      Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="success text-none"
                      flat
                      @click="submit"
                      :disabled="clicked"
                    >
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <v-card v-else-if="this.payment_method_id == 3">
                  <v-card-title class="indigo">
                    <div><span class="headline">Cheque Payment</span></div>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    <v-container grid-list-md>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row>
                          <v-flex xs6>
                            <v-subheader class="black--text">
                              Cheque Number:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.transaction_id"
                              :rules="[(v) => !!v || 'This field is required!']"
                              placeholder="Cheque number"
                              type="number"
                              box
                            ></v-text-field>
                            <v-subheader class="black--text">
                              Bank Name:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.bank_name"
                              :rules="[(v) => !!v || 'This field is required!']"
                              placeholder="Bank name"
                              box
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-subheader class="black--text">
                              Account Name:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.account_name"
                              :rules="[(v) => !!v || 'This field is required!']"
                              placeholder="Account name"
                              box
                            ></v-text-field>
                            <v-subheader class="black--text">
                              Account Number:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.account_number"
                              :rules="[(v) => !!v || 'This field is required!']"
                              type="number"
                              placeholder="Account number"
                              box
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Amount:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.paid_amount"
                              readonly
                              box
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Cheque Received Date:
                            </v-subheader>
                            <v-menu
                              ref="menu"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="190px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.cheque_receive_date"
                                  :rules="[
                                    (v) => !!v || 'This field is required!',
                                  ]"
                                  placeholder="YYY-MM-DD format"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  box
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="editedItem.cheque_receive_date"
                                :min="new Date().toISOString().substr(0, 10)"
                                @change="save"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Cheque Deposited Date:
                            </v-subheader>
                            <v-menu
                              ref="menu"
                              v-model="menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="190px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.cheque_deposit_date"
                                  :rules="[
                                    (v) => !!v || 'This field is required!',
                                  ]"
                                  placeholder="YYY-MM-DD format"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  box
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="editedItem.cheque_deposit_date"
                                :min="new Date().toISOString().substr(0, 10)"
                                @change="save"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Cheque Documents:
                            </v-subheader>
                          </v-flex>
                          <v-flex xs4 offset-sm2>
                            <v-subheader class="black--text">
                              Deposit Documents:
                            </v-subheader>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <ChequeImageUpload
                              @change="chequeImageUpload($event)"
                              select-text="Select file"
                            />
                          </v-flex>
                          <v-flex xs4 offset-sm2>
                            <ChequeDepositImage
                              @change="chequeDepositSlipUpload($event)"
                              select-text="Select file"
                            />
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn class="error text-none" flat @click="close">
                      Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="success text-none"
                      flat
                      @click="submit"
                      :disabled="clicked"
                    >
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <v-card v-else-if="this.payment_method_id == 4">
                  <v-card-title class="indigo">
                    <div><span class="headline">BEFTN Payment</span></div>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row>
                          <v-flex xs6>
                            <v-subheader class="black--text">
                              Transaction ID:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.transaction_id"
                              :rules="[(v) => !!v || 'This field is required!']"
                              placeholder="Transaction id"
                              box
                            ></v-text-field>
                            <v-subheader class="black--text">
                              Bank Name:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.bank_name"
                              :rules="[(v) => !!v || 'This field is required!']"
                              placeholder="Bank name"
                              box
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-subheader class="black--text">
                              Account Number:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.account_number"
                              :rules="[(v) => !!v || 'This field is required!']"
                              type="number"
                              placeholder="Account number"
                              box
                            ></v-text-field>
                            <v-subheader class="black--text">
                              Routing Number:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.beftn_routing_number"
                              :rules="[(v) => !!v || 'This field is required!']"
                              type="number"
                              placeholder="Account number"
                              box
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Amount:
                            </v-subheader>
                            <v-text-field
                              v-model="editedItem.paid_amount"
                              readonly
                              box
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Date:
                            </v-subheader>
                            <v-menu
                              ref="menu"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="190px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.trasanction_date"
                                  :rules="[
                                    (v) => !!v || 'This field is required!',
                                  ]"
                                  placeholder="YYY-MM-DD format"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  box
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="editedItem.trasanction_date"
                                :min="new Date().toISOString().substr(0, 10)"
                                @change="save"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4>
                            <v-subheader class="black--text">
                              Transaction Time:
                            </v-subheader>
                            <v-menu
                              ref="menu"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="editedItem.trasanction_time"
                                  :rules="[
                                    (v) => !!v || 'This field is required!',
                                  ]"
                                  placeholder="H:M format"
                                  readonly
                                  v-on="on"
                                  box
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu2"
                                v-model="editedItem.trasanction_time"
                                full-width
                                @click:minute="$refs.menu.save(time)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn class="error text-none" flat @click="close">
                      Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="success text-none"
                      flat
                      @click="submit"
                      :disabled="clicked"
                    >
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";
  import router from "../../../router";
  import { BkashImageUpload } from "@/components/index";
  import { ChequeImageUpload } from "@/components/index";
  import { ChequeDepositImage } from "@/components/index";

  export default {
    data: () => ({
      valid: true,
      dialog: false,
      clicked: false,
      apiUrl: "client-pay",
      editedIndex: -1,
      menu1: false,
      menu2: false,
      date: null,
      time: null,
      total_budget: "",
      perSurveyCost: "",
      payment_method_id: null,
      editedItem: {
        project_id: "",
        transaction_id: "",
        paid_amount: "",
        beftn_routing_number: "",
        trasanction_date: "",
        trasanction_time: "",
        transaction_photo: "",
        payment_method_id: "",
        payment_status_id: "",
        account_name: "",
        bank_name: "",
        account_number: "",
        cheque_receive_date: "",
        cheque_deposit_date: "",
        cheque_photo: "",
        deposit_slip_photo: "",
      },
      defaultItem: {
        project_id: "",
        transaction_id: "",
        paid_amount: "",
        beftn_routing_number: "",
        trasanction_date: "",
        trasanction_time: "",
        transaction_photo: "",
        payment_method_id: "",
        payment_status_id: "",
        account_name: "",
        bank_name: "",
        account_number: "",
        cheque_receive_date: "",
        cheque_deposit_date: "",
        cheque_photo: "",
        deposit_slip_photo: "",
      },
      budget: {
        total_budget_amount: "",
        total_budget_coins: "",
        per_survey_cost_coins: "",
        project_id: "",
      },
      phoneRules: [
        (v) => !!v || "Phone is required",
        (v) => (v && v.length == 11) || "Should be 11 digits.",
      ],
    }),
    components: {
      BkashImageUpload,
      ChequeImageUpload,
      ChequeDepositImage,
    },

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
    },

    watch: {
      menu(val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = "DATE"));
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let id = localStorage.getItem("projectId");
        this.budget.project_id = id;
        this.editedItem.project_id = id;
        this.$store.dispatch("paymentMethod", ["payment", id]);
        this.budget.total_budget_amount =
          this.indexData.datas.total_budget_amount;
        this.budget.total_budget_coins =
          this.indexData.datas.total_budget_amount * 10;
        this.budget.per_survey_cost_coins =
          this.indexData.datas.per_survey_cost * 10;
      },

      save(date) {
        this.$refs.menu.save(date);
        this.menu1 = false;
      },

      onImageChange(file) {
        var reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            // convert image file to base64 string
            let str = reader.result;
            let res = str.split(",");
            this.editedItem.transaction_photo = res[1];
          }.bind(this),
          false
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      },
      chequeImageUpload(file) {
        var reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            // convert image file to base64 string
            let str = reader.result;
            let res = str.split(",");
            this.editedItem.cheque_photo = res[1];
          }.bind(this),
          false
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      },
      chequeDepositSlipUpload(file) {
        var reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            // convert image file to base64 string
            let str = reader.result;
            let res = str.split(",");
            this.editedItem.deposit_slip_photo = res[1];
          }.bind(this),
          false
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      },
      paymentGateway() {
        // console.log(this.budget)
        alert("Currently it is not active, Please choose another option!");
        // this.budget.total_budget_amount = this.indexData.datas.total_budget_amount
        // this.budget.total_budget_coins = this.indexData.datas.total_budget_amount * 10
        // this.budget.per_survey_cost_coins = this.indexData.datas.per_survey_cost * 10
        // if (this.editedIndex > -1) {
        //   this.$store.dispatch('storePayment', [this.apiUrl, this.budget])
        //   // this.clicked = true
        // } else {
        //   this.$store.dispatch('storePayment', [this.apiUrl, this.budget])
        //   // this.clicked = true
        // }
      },
      bkash() {
        if (this.editedItem.paid_amount < 10) {
          alert("You cannot pay less 10");
        } else if (
          this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
        ) {
          alert(
            "You cannot pay greater than " +
              this.indexData.datas.total_budget_amount
          );
        } else if (
          this.editedItem.paid_amount < this.indexData.datas.payable_amount
        ) {
          alert(
            "You cannot pay less than " + this.indexData.datas.payable_amount
          );
        } else if (
          this.editedItem.paid_amount == null ||
          this.editedItem.paid_amount == undefined
        ) {
          alert("Pay minimum 10");
        } else {
          this.payment_method_id = 1;
          this.editedItem.payment_method_id = 1;
          this.editedItem.payment_status_id = 1;
          this.dialog = true;
        }
      },
      nagad() {
        if (this.editedItem.paid_amount < 10) {
          alert("You cannot pay less 10");
        } else if (
          this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
        ) {
          alert(
            "You cannot pay greater than " +
              this.indexData.datas.total_budget_amount
          );
        } else if (
          this.editedItem.paid_amount < this.indexData.datas.payable_amount
        ) {
          alert(
            "You cannot pay less than " + this.indexData.datas.payable_amount
          );
        } else if (
          this.editedItem.paid_amount == null ||
          this.editedItem.paid_amount == undefined
        ) {
          alert("Pay minimum 10");
        } else {
          this.payment_method_id = 2;
          this.editedItem.payment_method_id = 2;
          this.editedItem.payment_status_id = 1;
          this.dialog = true;
        }
      },
      cheque() {
        if (this.editedItem.paid_amount < 10) {
          alert("You cannot pay less 10");
        } else if (
          this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
        ) {
          alert(
            "You cannot pay greater than " +
              this.indexData.datas.total_budget_amount
          );
        } else if (
          this.editedItem.paid_amount < this.indexData.datas.payable_amount
        ) {
          alert(
            "You cannot pay less than " + this.indexData.datas.payable_amount
          );
        } else if (
          this.editedItem.paid_amount == null ||
          this.editedItem.paid_amount == undefined
        ) {
          alert("Pay minimum 10");
        } else {
          this.payment_method_id = 3;
          this.editedItem.payment_method_id = 3;
          this.editedItem.payment_status_id = 1;
          this.dialog = true;
        }
      },
      beftn() {
        if (this.editedItem.paid_amount < 10) {
          alert("You cannot pay less 10");
        } else if (
          this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
        ) {
          alert(
            "You cannot pay greater than " +
              this.indexData.datas.total_budget_amount
          );
        } else if (
          this.editedItem.paid_amount < this.indexData.datas.payable_amount
        ) {
          alert(
            "You cannot pay less than " + this.indexData.datas.payable_amount
          );
        } else if (
          this.editedItem.paid_amount == null ||
          this.editedItem.paid_amount == undefined
        ) {
          alert("Pay minimum 10");
        } else {
          this.payment_method_id = 4;
          this.editedItem.payment_method_id = 4;
          this.editedItem.payment_status_id = 1;
          this.dialog = true;
        }
      },
      back() {
        router.push("/payment-page");
      },
      submit() {
        if (this.$refs.form.validate()) {
          // console.log(this.editedItem)
          this.$store.dispatch("newTransaction", [
            "transaction",
            this.editedItem,
          ]);
          this.clicked = true;
        }
      },
      close() {
        this.dialog = false;
        this.payment_method_id = null;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
    },
  };
</script>

<style scoped>
  .icon {
    background: #ff2e2e;
    color: aliceblue;
    cursor: pointer;
    border-radius: none;
    margin: 10px;
  }
  .delete {
    color: #3f51b5;
    cursor: pointer;
  }
  span {
    width: 20px;
    cursor: pointer;
  }
  .button {
    font-size: 16px;
    background: #ff2e2e;
    padding: 0.4rem 1.3rem;
    text-align: center;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin: 10px;
    color: white;
  }
  .pay-button {
    font-size: 16px;
    background: #1565c0;
    padding: 0.4rem 1.3rem;
    text-align: center;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin: 10px;
    color: white;
  }
  .headline {
    color: white;
  }
  .project {
    background: #ff2e2e;
  }
</style>
